<template>
  <div class="md-layout ticket-wrapper">
    <div class="md-layout-item md-size-66">
      <md-field class="md-form-group" slot="inputs">
        <md-icon><i class="fas fa-tag text-primary hi-price-icon"></i></md-icon>
        <label>Ticket Title</label>
        <md-input v-model="ticket.title" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field class="md-form-group" slot="inputs">
        <md-icon
          ><i class="fas fa-ticket-alt text-primary hi-price-icon"></i
        ></md-icon>
        <label>Allocation</label>
        <md-input
          :readonly="!canEdit"
          type="number"
          v-model="ticket.allocation"
        ></md-input>
      </md-field>
    </div>

    <div class="md-layout-item md-size-33">
      <md-field class="md-form-group" slot="inputs">
        <md-icon
          ><i class="fas fa-pound-sign text-primary hi-price-icon"></i
        ></md-icon>
        <label>GBP</label>
        <md-input v-model="ticket.prices.gbp" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field class="md-form-group" slot="inputs">
        <md-icon
          ><i class="fas fa-euro-sign text-primary hi-price-icon"></i
        ></md-icon>
        <label>EUR</label>
        <md-input v-model="ticket.prices.eur" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field class="md-form-group" slot="inputs">
        <md-icon
          ><i class="fas fa-dollar-sign text-primary hi-price-icon"></i
        ></md-icon>
        <label>USD</label>
        <md-input v-model="ticket.prices.usd" type="text"></md-input>
      </md-field>
    </div>

    <div class="md-layout-item md-size-33"></div>
    <div class="md-layout-item md-size-33"></div>
    <div class="md-layout-item md-size-33 text-right">
      <md-button
        :disabled="!isDirty"
        class="md-just-icon md-simple md-success"
        @click.prevent="updateTicket(ticket)"
      >
        <md-icon>save</md-icon>
        <md-tooltip md-direction="top">Update this Ticket</md-tooltip>
      </md-button>
      <md-button
        class="md-just-icon md-simple md-danger"
        @click.prevent="removeTicket(ticket)"
      >
        <md-icon>remove_circle</md-icon>
        <md-tooltip md-direction="top">Remove this Ticket</md-tooltip>
      </md-button>
    </div>
  </div>
</template>
<script>
import confirm from "@/helpers/deleteConfirm";

export default {
  props: {
    ticket: Object
  },

  components: {},

  data() {
    return {
      isDirty: true
    };
  },

  methods: {
    updateTicket(ticket) {
      this.$emit("updateTicket", ticket);
    },

    removeTicket(ticket) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          this.$emit("removeTicket", ticket);
        }
      });
    }
  },

  computed: {
    canEdit() {
      return true; // Placeholder for permission logic
    }
  }
};
</script>
<style lang="scss" scoped>
.ticket-wrapper {
  border: 1px solid #ddd;
  border-radius: 7px;
  background-color: #f6f6f6;
  margin-bottom: 1em;
  padding-top: 10px;
}

.price-row {
  margin-bottom: 1rem;
}

h6.title {
  display: flex;
  align-items: center;
}
</style>
